import { render } from "./v-above.vue?vue&type=template&id=da044b72&scoped=true"
import script from "./v-above.vue?vue&type=script&lang=js"
export * from "./v-above.vue?vue&type=script&lang=js"

import "./v-above.vue?vue&type=style&index=0&id=da044b72&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da044b72"

export default script